export const APP_NAME = 'Viki Teams';
export const APP_NAME_UPPER = 'VIKI TEAMS';
